import { type FC, memo, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import WalletConnected from './wallet-connected';
import WalletUnconnect from './wallet-unconnect';
import { useModel } from 'foca';
import { walletConnectModel } from '@models/wallet-connect.model';
import { useCurrentWallet } from '@mysten/dapp-kit';
import { useAutoConnectWallet } from '@hooks/use-auto-connect-wallet';
import WalletDialog from './wallet-dialog';

const ConnectWallet: FC = () => {
  const wallet = useCurrentWallet();

  const [firstTime, setFirstTime] = useState(true);
  const autoConnect = useAutoConnectWallet();
  const showWallet = useModel(walletConnectModel, (state) => state.showWallet);

  useEffect(() => {
    if (!wallet.isConnected) return;
    if (autoConnect && firstTime) {
      setFirstTime(false);
    } else {
      toast('Connected to: ' + wallet.currentWallet.name);
    }
  }, [wallet.isConnected]);

  if (!showWallet) return null;
  return (
    <>
      {wallet.isConnected ? <WalletConnected /> : <WalletUnconnect />}
      <WalletDialog />
    </>
  );
};

export default memo(ConnectWallet);
